import { Injectable } from '@angular/core';
import { Icon } from './icon';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  iconsContext: any;
  icons: Icon[] = [];

  constructor() {
    this._getIcons();
  }

  get(glyph) {
    const ic = this.icons.find((icon) => icon.key === glyph);
    if (!ic) {
      console.warn(`icon [${glyph}] not found`);
    }
    return ic ? ic.content : '⧄';
  }

  private _getIcons(): void {
    this.iconsContext = import.meta.webpackContext('!raw-loader?esModule=false!./icons', { recursive: true, regExp: /\.svg$/ });

    this.iconsContext.keys().forEach((icon) => {
      this.icons.push({
        key: icon.replace('./', '').replace('.svg', ''),
        content: this.iconsContext(icon),
      });
    });
  }
}
